const BLOG_ACCESS = 'blog-access';
const LANDINGPAGES_ACCESS = 'landingpages-access';
const SERVICE_KNOWLEDGE_ACCESS = 'service-knowledge-access';
const SITEPAGES_ACCESS = 'sitepages-access';
const PAGES_ACCESS = 'pages-access';
export const SMS_SUBSCRIPTION_ACCESS = 'sms-marketing-addon';
export const WHATSAPP_SUBSCRIPTION_ACCESS = 'messaging-access';
const CRM_TRANSCRIPTION = 'crm-transcription';
const CRM_TRANSCRIPTION_ADMIN = 'crm-transcription-admin';
const SITE_CONTENT = [BLOG_ACCESS, LANDINGPAGES_ACCESS, SERVICE_KNOWLEDGE_ACCESS, SITEPAGES_ACCESS, PAGES_ACCESS];
export function hasSiteContentAccess(hasScope) {
  return SITE_CONTENT.some(hasScope);
}
export function hasTranscriptionFeature(hasScope) {
  return hasScope(CRM_TRANSCRIPTION);
}
export function hasTranscriptionAdminAccess(hasScope) {
  return hasScope(CRM_TRANSCRIPTION_ADMIN);
}